import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { Firma } from '../entities/schema/firma.entity';
import { BookingObject } from '../entities/schema/bookingobject.entity';
import { Status } from '../entities/settings/status.entity';
import { StatusType } from '../entities/settings/statustype.entity';
//#endregion

@Injectable()
export class BookingObjectService extends ODataEntityService<BookingObject> {
  constructor(protected client: ODataClient) {
    super(client, 'BookingObject', 'entities.schema.BookingObject');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  public freeBookingObjectsWithToken(): ODataFunctionResource<{bookingTimeId: number, date: Date, token: string}, BookingObject> {
    const resource = this.entities().function<{bookingTimeId: number, date: Date, token: string}, BookingObject>('services.FreeBookingObjectsWithToken');
    return resource;
  }
  //#endregion
  //#region ODataApi Navigations
  public firma(entity: EntityKey<BookingObject>): ODataNavigationPropertyResource<Firma> {
    return this.entity(entity).navigationProperty<Firma>('firma');
  }
  public status(entity: EntityKey<BookingObject>): ODataNavigationPropertyResource<Status> {
    return this.entity(entity).navigationProperty<Status>('status');
  }
  public statusType(entity: EntityKey<BookingObject>): ODataNavigationPropertyResource<StatusType> {
    return this.entity(entity).navigationProperty<StatusType>('statusType');
  }
  //#endregion
}
